import {
  makeStyles,
  Paper,
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import { Select } from "@material-ui/core";
import { Loading, Error, useAuthenticated } from "react-admin";
import { ThemeProvider } from "@material-ui/core/styles";
import { useState } from "react";

import useUsers from "../hooks/useUsers";
import MyAppBar from "../components/MyAppBar";
import theme from "../theme";

const useStyles = makeStyles((theme) => ({
  container: {
    width: 400,
    display: "grid",
    gridTemplateColumns: "50% 50%",

    gridAutoRows: "80px",
    rowGap: 10,
    columnGap: 10,

    padding: 20,
    alignItems: "center",
  },
  title: {
    gridArea: "title",
    justifySelf: "center",
    marginTop: 30,
    marginLeft: 20,
  },
  input: {
    height: 30,
    width: 200,
    justifySelf: "end",
  },
  inputText: {
    height: 30,
    width: 200,
    justifySelf: "start",
  },
  buttonContainer: {
    width: "100%",
    display: "grid",
  },
  button: {
    width: 300,
    height: 43,
    justifySelf: "center",
    fontSize: 20,
    margin: "20px auto 20px",
  },
}));

const ChangePasswordView = (props) => {
  const classes = useStyles();
  const { users, loading, error, changePassword } = useUsers();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [selectedUserId, setSelectedUserId] = useState();

  useAuthenticated();
  if (loading) return <Loading />;
  if (error) return <Error />;

  return (
    <ThemeProvider theme={theme}>
      <Paper className={classes.page}>
        <MyAppBar disabledMenu />
        <Typography variant="h2" className={classes.title}>
          Change password
        </Typography>
        <Box className={classes.container}>
          <Typography variant="h6">Username</Typography>
          <Select
            className={classes.input}
            label="Select user"
            value={selectedUserId?.username}
            onChange={(e) => setSelectedUserId(e.target.value)}
          >
            {users?.map((user) => (
              <MenuItem value={user} variant="outlined">
                {user.username}
              </MenuItem>
            ))}
          </Select>
          <Typography variant="h6">New password</Typography>
          <TextField
            className={classes.inputText}
            label=""
            value={password}
            variant="outlined"
            onChange={(e) => setPassword(e.target.value)}
            error={password?.length < 8 ? true : null}
            helperText={
              password?.length < 8 ? "Need more than 8 characters" : null
            }
          ></TextField>
          <Typography variant="h6">Confirm password</Typography>
          <TextField
            className={classes.inputText}
            label=""
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={password !== confirmPassword}
            helperText={
              password !== confirmPassword ? "Password does not match" : null
            }
          ></TextField>
        </Box>
        <Box className={classes.buttonContainer}>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            disabled={
              password !== confirmPassword ||
              !password ||
              !confirmPassword ||
              !selectedUserId
            }
            onClick={() => changePassword(selectedUserId.id, password)}
          >
            Save
          </Button>
        </Box>
      </Paper>
    </ThemeProvider>
  );
};

export default ChangePasswordView;
